export default __webpack_public_path__ + "static/international-metric-mobile-b519e4b04b102d3b5fea2bc9af1a6bb1.svg";